import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints'

const StyledHome = styled.div`

h2{
  font-size: 42px;
  padding: 32px 0;
  width: 80%;

  @media (max-width: ${breakpoints.medium}) {
    font-size: 28px;
    padding: 20px 0;
  }
}

.interactve-api{
  position: relative;
  padding: 40px;
  padding-bottom: 80px;
  height: auto;
  width: calc(100vw - 80px);
  border-bottom: 1px solid rgba(var(--greyr), 0.3);
  display: flex;
  overflow: hidden;
  flex-direction: column;
  border-top: 1px solid rgba(var(--greyr), 0.3);
  background-color: rgba(var(--whiter), 0.95);
  &:before{
    width: 100vw;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url('/ls.webp');
    background-size: cover;
    background-position: center;
    z-index: -1;
    content: '';
  }
  .text{
    display: flex;
    padding-bottom: 40px;
    flex-direction: column;
    max-width: 1920px;
    margin: 0 auto;
    width: 100%;

  }
}

.blog{
  padding-top: 120px;
  padding-bottom: 60px;

  @media (max-width: ${breakpoints.medium}) {
    padding-bottom: 60px;
  }

}

`;


export default StyledHome;
